export default __webpack_public_path__ + "static/media/takeoff.acdcf50d.jpg";